import { useState } from 'react';
import DatePickerRange from 'src/components/date-picker-range/DatePickerRange';
import CrossIcon from 'src/icons/cross';
import downIcon from 'src/icons/down.svg';
import { dateToFormattedStr } from 'src/utils/dates';
import { truncate } from 'src/utils/strings';

const DatepickerDropdownFilter = ({ onDatesChange, startDate, endDate, onResetClick }) => {
    const [open, setOpen] = useState();

    return (
        <button
            className={`ml-2 flex justify-center items-center rounded-full w-48 text-sm py-2 px-5 h-11 mt-2 ${
                startDate && endDate ? 'bg-[#008EC81A]' : 'bg-gray-light'
            }`}
        >
            <DatePickerRange
                className={`flex justify-between items-center w-full ${
                    startDate && endDate ? 'text-blue-dark' : 'text-gray-darker'
                }`}
                onDatesChange={onDatesChange}
                initialStartDate={startDate}
                initialEndDate={endDate}
                setOpen={setOpen}
            >
                {startDate && endDate
                    ? truncate(`${dateToFormattedStr(startDate)} - ${dateToFormattedStr(endDate)}`, 14)
                    : 'Date'}
                {startDate && endDate ? (
                    <CrossIcon color="#008EC8" onClick={onResetClick} className="ml-auto" />
                ) : (
                    <img src={downIcon} alt="down arrow" className={(open ? 'rotate-180' : '') + ' ml-auto'} />
                )}
            </DatePickerRange>
        </button>
    );
};

export default DatepickerDropdownFilter;
